module.exports = __webpack_public_path__ + "img/仙人掌-3.b9d32a5b.jpg";